export const overlayCloseReasons = {
  INTERACT_OUTSIDE: 'interact_outside',
  INTERACT_PARENT: 'interact_parent',
  ESCAPE: 'escape',
  SCROLL: 'scroll',
  OVERLAY_OPEN: 'overlay_open',
};
